module.exports = __webpack_public_path__ + "img/banner-pack-mobile.d9f6516d.png";